<div class="main-card shadow-sm h-100">
  <!-- Header -->
  <div class="d-flex justify-content-between align-items-center mb-3">
    <div class="d-flex align-items-center gap-2">
      <fa-icon [icon]="faBox" class="text-blue" style="font-size: 14px;"></fa-icon>
      <span class="main-heading fw-smbold">Returns From Customer</span>
    </div>
    @if (returnsFromCustomer.length > 5) {
    <button class="btn view-all-btn d-flex align-items-center gap-1" (click)="viewAllReturns(returnsModal)">
      View all <fa-icon [icon]="faChevronRight" style="font-size: 10px;"></fa-icon>
    </button>
    }
  </div>

  <div class="table-box">
    <table class="table custom-table border-0 mb-0">
      <thead>
        <tr>
          <th class="fw-smbold border-0">SKU</th>
          <th class="fw-smbold border-0">Branch</th>
          <th class="text-end fw-smbold border-0">Quantity</th>
        </tr>
      </thead>
      <tbody>
        <!-- Loader State -->
        @if (loader) {
        <tr>
          <td colspan="3" class="text-center py-4 border-0">
            <app-loader [loadingIcon]="loader"></app-loader>
          </td>
        </tr>
        }

        <!-- Error State -->
        @if (!loader && errMsg) {
        <tr>
          <td colspan="3" class="text-center py-4 border-0">
            <p class="text-danger mb-0 small fw-bold">{{ errMsg }}</p>
          </td>
        </tr>
        }

        <!-- Data State -->
        @if (!loader && !errMsg) {
        @for (item of returnsFromCustomer | slice:0:5; track item) {
        <tr>
          <td class="td-col-1 border-0 text-break">{{ item.tyreMake }} {{item.tyreModel}} · {{item.tyreSize}}</td>
          <td class="td-col-1 border-0">{{ item.companyName }}</td>
          <td class="text-end td-col-3 fw-bold border-0">
            @if (item.quantity !== null) {
            {{ item.quantity | number }}
            } @else {
            -
            }
          </td>
        </tr>
        }
        }
      </tbody>
    </table>
  </div>
</div>

<!-- Modal Template -->
<ng-template #returnsModal let-modal>
  <div class="modal-header border-0 pb-0">
    <h5 class="fw-bold mb-0 main-heading">All Returns From Customer</h5>
    <button type="button" class="btn-close" aria-label="Close" (click)="modal.dismiss('Cross click')"></button>
  </div>

  <div class="modal-body p-2 p-md-4">
    <div class="table-responsive table-container">
      <table class="table custom-table border-0 mb-0">
        <thead>
          <tr>
            <th class="fw-smbold border-0">SKU</th>
            <th class="fw-smbold border-0">Branch</th>
            <th class="text-end fw-smbold border-0">Quantity</th>
          </tr>
        </thead>
        <tbody>
          @if (returnsFromCustomer.length > 0) {
          @for (item of returnsFromCustomer; track item) {
          <tr>
            <td class="td-col-1 border-0 text-break">{{ item.tyreMake }} {{item.tyreModel}} · {{item.tyreSize}}</td>
            <td class="td-col-1 border-0">{{ item.companyName }}</td>
            <td class="text-end td-col-3 fw-bold border-0">
              @if (item.quantity !== null) {
              {{ item.quantity | number }}
              } @else {
              -
              }
            </td>
          </tr>
          }
          }
          @if (returnsFromCustomer.length === 0) {
          <tr>
            <td colspan="3" class="text-center py-4 border-0">
              <p class="text-muted mb-0 small fw-bold">No returns found.</p>
            </td>
          </tr>
          }
        </tbody>
      </table>
    </div>
  </div>
</ng-template>
